import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./lesson-assessment-leaderboard.css";
import ASSETS from "../../../../app/config/assets";
import Button from "../../../../ui/atoms/buttons/Button";
import { GiPodiumWinner, GiPodiumSecond, GiPodiumThird } from "react-icons/gi";
import { PiHandsClappingLight } from "react-icons/pi";
import { capitalize } from "../../../../core/utils/helpers";
import { useDispatch, useSelector } from "react-redux";
import { challengeSlice } from "../../../../app/store/slices/challengeSlice";
import LessonAssessmentReport from "../lesson-assessment-report/LessonAssessmentReport";

const LessonAssessmentLeaderBoard = ({ is_completed, data, setView }) => {
  const [isReport, setIsReport] = useState();
  const _scoreboard = data?.scores;
  const _report = data?.report;
  const _total_questions = data?.total_questions;

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const connectedUser = useSelector(
    (state) => state.setInitConf.initConnectedUser.connectedUserData,
  );

  const _sys_role = connectedUser?.userInfo?.sys_role;

  const goToHome = () => {
    if (is_completed) {
      dispatch(
        challengeSlice?.actions?.setLessonAssessment({
          assessment_type: null, // LA stand for Lesson Assessment
          assessment_mode: null,
          assessment_id: null,
          assessment_invitation_id: null,
        }),
      );
      navigate(`/${_sys_role}`, { replace: true });
    } else {
      setView("preload");
    }
  };

  return (
    <div className="leaderboard">
      <div className="leaderboard-wrapper">
        <div className="lw-head">
          <h1>Lesson Assessment's {isReport ? "Report" : "Scoreboard"}</h1>
          <Button
            type={"button"}
            preferedStyle={"default"}
            title={
              is_completed
                ? "Finish and Close Report"
                : "Close and Go to Next question!"
            }
            action={() => goToHome()}
          />
        </div>
        <div className="lw-actions">
          <Button
            type={"button"}
            preferedStyle={isReport ? "default" : "normal"}
            title={"Click to view ScoresBoard"}
            action={() => setIsReport(!isReport)}
          />
          <Button
            type={"button"}
            preferedStyle={isReport ? "normal" : "default"}
            title={"Click to view Report"}
            action={() => setIsReport(!isReport)}
          />
        </div>
        <div className="lw-ruban">
          {isReport ? (
            <span>
              This is Lesson Assessment's report that present questions and
              every single details about for a good{" "}
              <strong>understanding.</strong>
            </span>
          ) : (
            <span>
              This is Lesson Assessment's evolution of the{" "}
              <strong>scoreboard and Podium</strong>
            </span>
          )}
        </div>
        <div className="lw-body">
          {isReport ? (
            <LessonAssessmentReport report_data={_report} />
          ) : (
            <React.Fragment>
              <div className="classment">
                {_scoreboard?.map((item, idx) => {
                  switch (parseInt(item?.ranking)) {
                    case 1:
                      return (
                        <div className="box box-1" key={idx + 1}>
                          <img
                            src={ASSETS.first}
                            alt="player ranking at first place"
                          />
                          <h2 className="title t-2">
                            {`${capitalize(item?.firstname)} ${capitalize(item?.lastname)}`}
                          </h2>
                          <h3 className="title t-3">
                            {item?.total_lesson_assessment_points_won} Points
                          </h3>
                          <p className="title t-4">
                            {item?.failed_questions + item?.success_questions}{" "}
                            out of {_total_questions} question(s)
                          </p>
                        </div>
                      );

                    case 2:
                      return (
                        <div className="box box-2" key={idx + 1}>
                          <img
                            src={ASSETS.second}
                            alt="player ranking at second place"
                          />
                          <h2 className="title t-2">
                            {`${capitalize(item?.firstname)} ${capitalize(item?.lastname)}`}
                          </h2>
                          <h3 className="title t-3">
                            {item?.total_lesson_assessment_points_won} Points
                          </h3>
                          <p className="title t-4">
                            {item?.failed_questions + item?.success_questions}{" "}
                            out of {_total_questions} question(s)
                          </p>
                        </div>
                      );

                    case 3:
                      return (
                        <div className="box box-3" key={idx + 1}>
                          <img
                            src={ASSETS.third}
                            alt="player ranking at third place"
                          />
                          <h2 className="title t-2">
                            {`${capitalize(item?.firstname)} ${capitalize(item?.lastname)}`}
                          </h2>
                          <h3 className="title t-3">
                            {item?.total_lesson_assessment_points_won} Points
                          </h3>
                          <p className="title t-4">
                            {item?.failed_questions + item?.success_questions}{" "}
                            out of {_total_questions} question(s)
                          </p>
                        </div>
                      );

                    default:
                      if (
                        (parseInt(item?.ranking) === 0 ||
                          parseInt(item?.ranking) > 3 ||
                          item?.ranking === "-") &&
                        item?.is_me
                      )
                        return (
                          <div className="box box-4" key={idx + 1}>
                            <span>Me</span>
                            <h2 className="title t-2">
                              {`${capitalize(item?.firstname)} ${capitalize(item?.lastname)}`}
                            </h2>
                            <h3 className="title t-3">
                              {item?.total_lesson_assessment_points_won} Points
                            </h3>
                            <p className="title t-4">
                              {item?.failed_questions + item?.success_questions}{" "}
                              out of {_total_questions} question(s)
                            </p>
                            <h3 className="title t-2">
                              {item?.ranking}
                              <sup>th</sup> place
                            </h3>
                          </div>
                        );
                  }
                })}
              </div>
              <div className="lw-content">
                {_scoreboard?.map((item, idx) => {
                  switch (parseInt(item?.ranking)) {
                    case 1:
                      return (
                        <div className="lw-content-item" key={idx + 1}>
                          <span className="position p-first">
                            {item?.ranking}
                          </span>
                          <GiPodiumWinner className="icon icon-first" />
                          <div className="player player-1">
                            <img
                              src={process.env.PUBLIC_URL + "/user.png"}
                              alt="player-profile"
                            />
                            <div className="names">
                              <h1>{`${capitalize(item?.firstname)} ${capitalize(item?.lastname)}`}</h1>
                              <p>{item?.origin_country}</p>
                            </div>
                            <div className="tile">
                              <span>Points</span>
                              <p>{item?.total_lesson_assessment_points_won}</p>
                            </div>
                            <div className="tile">
                              <span>Current Question</span>
                              <p>{item?.current_question_number || "--"}</p>
                            </div>
                            {item?.is_me && (
                              <React.Fragment>
                                <div className="tile">
                                  <span>Success Question</span>
                                  <p>{item?.success_questions}</p>
                                </div>
                                <div className="tile">
                                  <span>Failed Question</span>
                                  <p>{item?.failed_questions}</p>
                                </div>
                                <div className="tile">
                                  <span>Timeout Failed Question</span>
                                  <p>{item?.timeout_failed_questions}</p>
                                </div>
                              </React.Fragment>
                            )}
                          </div>
                        </div>
                      );

                    case 2:
                      return (
                        <div className="lw-content-item" key={idx + 1}>
                          <span className="position p-second">
                            {item?.ranking}
                          </span>
                          <GiPodiumSecond className="icon icon-second" />
                          <div className="player player-2">
                            <img
                              src={process.env.PUBLIC_URL + "/user.png"}
                              alt="player-profile"
                            />
                            <div className="names">
                              <h1>{`${capitalize(item?.firstname)} ${capitalize(item?.lastname)}`}</h1>
                              <p>{item?.origin_country}</p>
                            </div>
                            <div className="tile">
                              <span>Points</span>
                              <p>{item?.total_lesson_assessment_points_won}</p>
                            </div>
                            <div className="tile">
                              <span>Current Question</span>
                              <p>{item?.current_question_number || "--"}</p>
                            </div>
                            {item?.is_me && (
                              <React.Fragment>
                                <div className="tile">
                                  <span>Success Question</span>
                                  <p>{item?.success_questions}</p>
                                </div>
                                <div className="tile">
                                  <span>Failed Question</span>
                                  <p>{item?.failed_questions}</p>
                                </div>
                                <div className="tile">
                                  <span>Timeout Failed Question</span>
                                  <p>{item?.timeout_failed_questions}</p>
                                </div>
                              </React.Fragment>
                            )}
                          </div>
                        </div>
                      );

                    case 3:
                      return (
                        <div className="lw-content-item" key={idx + 1}>
                          <span className="position p-third">
                            {item?.ranking}
                          </span>
                          <GiPodiumThird className="icon icon-third" />
                          <div className="player player-3">
                            <img
                              src={process.env.PUBLIC_URL + "/user.png"}
                              alt="player-profile"
                            />
                            <div className="names">
                              <h1>{`${capitalize(item?.firstname)} ${capitalize(item?.lastname)}`}</h1>
                              <p>{item?.origin_country}</p>
                            </div>
                            <div className="tile">
                              <span>Points</span>
                              <p>{item?.total_lesson_assessment_points_won}</p>
                            </div>
                            <div className="tile">
                              <span>Current Question</span>
                              <p>{item?.current_question_number || "--"}</p>
                            </div>
                            {item?.is_me && (
                              <React.Fragment>
                                <div className="tile">
                                  <span>Success Question</span>
                                  <p>{item?.success_questions}</p>
                                </div>
                                <div className="tile">
                                  <span>Failed Question</span>
                                  <p>{item?.failed_questions}</p>
                                </div>
                                <div className="tile">
                                  <span>Timeout Failed Question</span>
                                  <p>{item?.timeout_failed_questions}</p>
                                </div>
                              </React.Fragment>
                            )}
                          </div>
                        </div>
                      );

                    default:
                      return (
                        <div className="lw-content-item" key={idx + 1}>
                          <span className="position">{item?.ranking}</span>
                          <PiHandsClappingLight className="icon icon-remain-places" />
                          <div className="player">
                            <img
                              src={process.env.PUBLIC_URL + "/user.png"}
                              alt="player-profile"
                            />
                            <div className="names">
                              <h1>{`${capitalize(item?.firstname)} ${capitalize(item?.lastname)}`}</h1>
                              <p>{item?.origin_country}</p>
                            </div>
                            <div className="tile">
                              <span>Points</span>
                              <p>{item?.total_lesson_assessment_points_won}</p>
                            </div>
                            <div className="tile">
                              <span>Current Question</span>
                              <p>{item?.current_question_number || "--"}</p>
                            </div>
                            {item?.is_me && (
                              <React.Fragment>
                                <div className="tile">
                                  <span>Success Question</span>
                                  <p>{item?.success_questions}</p>
                                </div>
                                <div className="tile">
                                  <span>Failed Question</span>
                                  <p>{item?.failed_questions}</p>
                                </div>
                                <div className="tile">
                                  <span>Timeout Failed Question</span>
                                  <p>{item?.timeout_failed_questions}</p>
                                </div>
                              </React.Fragment>
                            )}
                          </div>
                        </div>
                      );
                  }
                })}
              </div>
            </React.Fragment>
          )}
        </div>
      </div>
    </div>
  );
};

export default LessonAssessmentLeaderBoard;
